module.exports = __webpack_public_path__ + "media/mem_coin_m.73030a61.mp4";